<script setup>

const props = defineProps({
	color: String,
})

</script>

<template >
	<svg width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M19.3297 39.4143C30.0051 39.4143 38.6593 30.5911 38.6593 19.7072C38.6593 8.8232 30.0051 0 19.3297 0C8.65418 0 0 8.8232 0 19.7072C0 30.5911 8.65418 39.4143 19.3297 39.4143Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
		<path
			d="M17.0264 14.9954H21.6478V34.0271H21.4664C19.0216 34.0271 17.0343 32.0009 17.0343 29.5084V14.9954H17.0264Z"
			fill="white"
		/>
		<path
			d="M19.3296 11.6588C21.0283 11.6588 22.4053 10.2548 22.4053 8.52298C22.4053 6.79114 21.0283 5.38721 19.3296 5.38721C17.6309 5.38721 16.2539 6.79114 16.2539 8.52298C16.2539 10.2548 17.6309 11.6588 19.3296 11.6588Z"
			fill="white"
		/>
	</svg>
</template>